import { __awaiter } from "tslib";
import { PerspectiveCamera, Vector3 } from "three";
export function fitCameraToBoundingBox(_a) {
    return __awaiter(this, arguments, void 0, function* ({ camera, boundingBox, offset, width, height, initialY, direction, target, smooth, setCameraInPositionAndTarget, }) {
        var _b, _c;
        offset = offset || 1.25;
        if (!width || !height) {
            console.warn("Viewport has no size, cannot fit the camera");
            return;
        }
        if (boundingBox.isEmpty()) {
            console.warn("Bounding box is empty, cannot fit the camera");
            return;
        }
        const center = (_b = target === null || target === void 0 ? void 0 : target.clone()) !== null && _b !== void 0 ? _b : boundingBox.getCenter(new Vector3());
        if (camera instanceof PerspectiveCamera) {
            const forward = ((_c = direction === null || direction === void 0 ? void 0 : direction.clone()) !== null && _c !== void 0 ? _c : new Vector3(0, (initialY !== null && initialY !== void 0 ? initialY : 0) / 10, 1)).normalize();
            const distance = computeFitDistance(boundingBox, center, forward, camera.fov, width / height, offset);
            const position = center.clone().sub(forward.multiplyScalar(distance));
            yield setCameraInPositionAndTarget("perspective", position, center, smooth);
        }
        else {
            const size = boundingBox.getSize(new Vector3());
            const ratio = height / width;
            const maxDim = Math.max(size.x, size.y, size.z) * ratio;
            const cam = camera;
            cam.zoom = (width / maxDim) * 0.9;
            camera.position.x = center.x;
            camera.position.y = initialY * 0.1;
            camera.position.z = -center.z - maxDim;
            camera.updateProjectionMatrix();
        }
    });
}
/**
 * Distance from `center` (along `-forward`) at which every corner of the box
 * fits inside the frustum, checking both the horizontal and the vertical FOV.
 * `center` doesn't have to be the center of the box.
 * `offset` is the frame margin: 1.25 makes the box take 1/1.25 of the limiting axis.
 */
function computeFitDistance(boundingBox, center, forward, fovInDegrees, aspect, offset) {
    const worldUp = Math.abs(forward.y) > 0.999 ? new Vector3(0, 0, 1) : new Vector3(0, 1, 0);
    const right = new Vector3().crossVectors(forward, worldUp).normalize();
    const up = new Vector3().crossVectors(right, forward).normalize();
    const tanV = Math.tan((fovInDegrees * Math.PI) / 180 / 2);
    const tanH = tanV * aspect;
    const { min, max } = boundingBox;
    const corner = new Vector3();
    let distance = 0;
    for (let i = 0; i < 8; i++) {
        corner.set(i & 1 ? max.x : min.x, i & 2 ? max.y : min.y, i & 4 ? max.z : min.z).sub(center);
        const x = Math.abs(corner.dot(right)) * offset;
        const y = Math.abs(corner.dot(up)) * offset;
        const z = corner.dot(forward); // > 0 means farther than the center
        distance = Math.max(distance, x / tanH - z, y / tanV - z);
    }
    return distance;
}
